import { Component, OnInit } from '@angular/core';
import { BrandingService } from './services/branding.service';
import { LanguageService } from './services/language.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'Menassaty-FE';

  constructor(private language: LanguageService, private branding: BrandingService) {}

  ngOnInit() {
    // Re-apply persisted tenant branding (colors) on every load.
    this.branding.applyStored();

    // Resolve language + document direction (saved preference → browser → en).
    this.language.init();
  }
}
